import Column from "../../../Tables/Column";

const AddNewUserReportFieldColumns = [
  new Column("id_report_column_list", "ID", 100, {hiddenByDefault: true}),
  new Column("name_column", "Наименование", 500, {auto: true}),
  new Column("system_name", "Поле (файла)", 200),
];

export default AddNewUserReportFieldColumns;
